import React, { Fragment } from "react";
import { Row, StatusTable, CardSubHeader } from "@egovernments/digit-ui-react-components";

const ProfessionalsAddressMapper = ({ data, t }) => {
  const erKeys = Object.keys(data).filter(key => key.startsWith("er") && !key.includes("engineerUuid") && !key.includes("erplotArea"));
  const stringKeys = Object.keys(data).filter(key => !key.startsWith("er") && !key.includes("engineerUuid") && typeof data[key] === "string" && data[key] !== null);

  return (
    <Fragment>
    <div style={{ marginTop: "19px", background: "#FAFAFA", border: "1px solid #D6D5D4", borderRadius: "4px", padding: "8px", lineHeight: "19px", maxWidth: "960px", minWidth: "280px" }}>
      <CardSubHeader>{t("CORE_COMMON_PRIVATE_PROFESSIONAL_INFORMATION")}</CardSubHeader>
      <StatusTable>
        {stringKeys.map((key, index) => (
          <Row
            key={index}
            className="border-none"
            label={t(`CORE_COMMON_${key.toUpperCase()}`)}
            text={data[key] || ""}
          />
        ))}
      </StatusTable>
    </div>
    <div style={{ marginTop: "19px", background: "#FAFAFA", border: "1px solid #D6D5D4", borderRadius: "4px", padding: "8px", lineHeight: "19px", maxWidth: "960px", minWidth: "280px" }}>
      <CardSubHeader>{t("CORE_COMMON_STRUCTURAL_ENGINEER_INFORMATION")}</CardSubHeader>
      <StatusTable>
        {erKeys.map((key, index) => (
          <Row
            key={index}
            className="border-none"
            label={t(`CORE_COMMON_${key.slice(2).toUpperCase()}`)}
            text={data[key] || ""}
          />
        ))}
      </StatusTable>
    </div>
    </Fragment>
  );
};

export default ProfessionalsAddressMapper;
